import React from 'react';
import { useNavigate } from 'react-router-dom';
import './News.css';

/**
 * A visible path to /news from the pages whose tickers feed it (Portfolio,
 * Watchlists). Added 2026-10-05 after he found the per-ticker strip and then
 * asked where the news for his portfolio and watchlists was: the feed was
 * only in the nav, and the page you are already on is where you look.
 */
export default function NewsLink({ label }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="nf-entry" onClick={() => navigate('/news')}>
      <span aria-hidden="true">📰</span>
      <span>{label}</span>
      <span className="nf-entry-arrow" aria-hidden="true">→</span>
    </button>
  );
}
